import { useSuspenseQuery } from '~/services'
import { SALE_EVENTS } from '../constants/saleEvents'
import { Plan } from '../types/index'
import { useActiveSubscription } from './useActiveSubscription'

export type Coupon = {
  id: string
  displayName: string
  percentOff?: number
  amountOff?: number
}

export const useCoupon = (workspaceId: string) => {
  const { monthly: monthlyActiveSubscription, yearly: yearlyActiveSubscription } = useActiveSubscription(workspaceId)
  const { data: promoCode } = useSuspenseQuery('workspaces_/$workspaceId_/billing/promoCode', { workspaceId })

  return (upcomingPlan: { legacyName: Plan; pricePerMonth: number | undefined }) => {
    let coupon: Coupon | undefined = undefined

    if (yearlyActiveSubscription?.discount?.coupon) {
      const subscriptionCoupon = yearlyActiveSubscription?.discount?.coupon

      const saleEvent = SALE_EVENTS.find(
        (saleEvent) => saleEvent.planDiscounts[upcomingPlan.legacyName]?.yearly?.couponId === subscriptionCoupon.id
      )
      const percentOff = saleEvent?.planDiscounts[upcomingPlan.legacyName]?.percentOff

      if (saleEvent && percentOff)
        // AmountOff is not necessary for the yearly subs as the customer already paid the invoice
        coupon = {
          id: subscriptionCoupon.id,
          displayName: saleEvent.displayName,
          percentOff,
        }
    } else if (monthlyActiveSubscription?.discount?.coupon && upcomingPlan.pricePerMonth) {
      const subscriptionCoupon = monthlyActiveSubscription?.discount?.coupon

      const saleEvent = SALE_EVENTS.find(
        (saleEvent) => saleEvent.planDiscounts[upcomingPlan.legacyName]?.monthly?.couponId === subscriptionCoupon.id
      )

      const amountOff = subscriptionCoupon.percent_off
        ? (upcomingPlan.pricePerMonth * subscriptionCoupon.percent_off) / 100
        : subscriptionCoupon.amount_off

      const percentOff = saleEvent?.planDiscounts[upcomingPlan.legacyName]?.percentOff

      if (saleEvent && amountOff)
        coupon = {
          id: subscriptionCoupon.id,
          displayName: saleEvent.displayName,
          amountOff,
          percentOff,
        }
    } else if (promoCode && upcomingPlan.pricePerMonth) {
      // promoCodes can only be applied to monthly subs

      const saleEvent = SALE_EVENTS.find(
        (saleEvent) => saleEvent.planDiscounts[upcomingPlan.legacyName]?.monthly?.couponId === promoCode.code
      )

      const percentOff = promoCode.coupon.percentOff / 100

      if (saleEvent) {
        const amountOff = upcomingPlan.pricePerMonth * percentOff
        coupon = {
          id: promoCode.code,
          displayName: saleEvent.displayName,
          amountOff,
          percentOff,
        }
      }
    }

    return coupon
  }
}
